const t = {
  name: "Blocked",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM6.38225 4.96815C7.92193 3.73649 9.87496 3 12 3C16.9706 3 21 7.02944 21 12C21 14.125 20.2635 16.0781 19.0318 17.6178L6.38225 4.96815ZM4.96805 6.38238L17.6176 19.032C16.078 20.2635 14.125 21 12 21C7.02944 21 3 16.9706 3 12C3 9.87502 3.73645 7.92204 4.96805 6.38238Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Blocked
};
